import React from 'react';
import { CUSTOMER_LOGOS } from './landingData';

export function CustomersSection() {
  return (
    <section className="py-10 md:py-20 bg-slate-50" aria-label="Our Customers">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">

        <div className="text-center mb-8 md:mb-12">
          <p className="text-xs font-bold tracking-widest text-orange-500 uppercase mb-3">Our Customers</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-3">
            Trusted by businesses across industries
          </h2>
          <p className="text-slate-500 text-base">
            Growing businesses around the world rely on ReStaff to manage their teams.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 items-center justify-items-center">
          {CUSTOMER_LOGOS.map((logo, index) => (
            <React.Fragment key={logo.alt}>
              {/* On xl (6-col), 16 logos = 2 full rows + 4 remaining. Insert spacer before item 13 to center last row */}
              {index === 12 && <div className="hidden xl:block w-full h-24" />}
              <div
                className="flex items-center justify-center bg-white rounded-xl border border-slate-100 shadow-sm p-4 w-full"
                style={{ height: '96px' }}
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  loading="lazy"
                  style={{
                    maxHeight: '56px',
                    width: 'auto',
                    maxWidth: '100%',
                    objectFit: 'contain',
                    filter: 'grayscale(80%)',
                    transition: 'filter 0.3s ease',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.filter = 'grayscale(0%)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.filter = 'grayscale(80%)'; }}
                />
              </div>
            </React.Fragment>
          ))}
        </div>

      </div>
    </section>
  );
}
